import { createStyles, makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles(function (theme) { return createStyles({
    selector: {
        margin: '8px 16px',
        width: '100%',
        border: '1px solid transparent',
        color: theme.palette.text.primary,
        background: 'rgba(255, 255, 255, 0.08)',
        borderRadius: '8px',
        '&:hover': {
            background: theme.palette.action.hover,
        },
        '&--open': {
            border: '1px solid #d0d0d0',
            borderRadius: '8px',
            background: 'none',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
        '&--small': {
            background: 'none',
        },
    },
    selectorLabel: {
        fontSize: '0.8rem',
        margin: 0,
        whiteSpace: 'normal',
        transition: 'opacity 225ms linear',
        height: '34px',
        display: 'flex',
        alignItems: 'center',
    },
    listItem: {
        minWidth: '14px',
        color: theme.palette.text.secondary,
        alignItems: 'center',
        flexDirection: 'column',
        transition: 'opacity 225ms linear, width 225ms cubic-bezier(0.4, 0, 0.6, 1), background-color 225ms linear',
        '& div': {
            fill: theme.palette.text.secondary,
        },
        '&--selected': {
            color: theme.palette.primary.main,
            '& div': {
                fill: theme.palette.primary.main,
            },
        },
    },
    listItemIcon: {
        fontSize: '14px',
        position: 'relative',
    },
    avatar: {
        left: '0px',
        '&--small': {
            transition: 'left 225ms linear',
            position: 'relative',
            left: '7px',
        },
    },
}); });
//# sourceMappingURL=sideAppsMenuStyle.js.map